define('drops/dataGrid/dataGrid',[
    'jquery',
    'when',
    'lq/drop',
    'lq/style',
    'underscore',
    'lq/util',
    'lq',
    'lq/eventSource',
    'lq/windowSize',
    'lq/dynamicContentImage',
    'lq/tooltip',
    'lq/html'
], function($, when, Drop, Style, _, util, lq, EventSource, windowSize, dynamicContentImage, Tooltip, html) {
    'use strict';

    var defaults = {
        data: {
            showNavigationAtTop: false,
            showNavigationAtBottom: true,
            pageSize: 100,
            page: 0,
            headerHeight: 25,
            rowHeight: 25,
            headerEnabled: true,
            selection: 'single',
            defaultSortOutput: null,
            defaultSortDirection: null,
            infiniteScroll: true,
        }
    };

    var setBackgroundImage = function ($el, physicalFile) {
        var background = ''
        if (physicalFile && physicalFile !== '') {
            var url = lq.getTenantUploads(physicalFile);
            background = url
                ? 'url(' + url + ')'
                : '';
        }
        $el.css('background-image', background);
    };

    var horizontalAlignmentToFlex = {
        inherit: 'flex-start',
        left: 'flex-start',
        center: 'center',
        right: 'flex-end'
    };

    function DataGrid(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        EventSource.call(this, [
            'PageOpened'
        ]);

        this.data.columns = _.map(this.data.columns, function (column) {
            return util.convertListOfKeyValuesToObject(column);
        });

        this.results = null;
        var self = this;

        this.$tableHeaders = null;
        this.$tableRows = null;
        this.$element.css({
            'visibility': 'inherit',
            overflow: 'hidden'
        });

        this.$dataGridWrapper = $('<div/>')
            .css({
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                whiteSpace: 'pre-wrap'
            })
            .addClass('data-grid-wrapper')
            .appendTo(this.$element);

        this.$headerWrapper = $('<div/>')
            .addClass('header-wrapper header')
            .appendTo(this.$dataGridWrapper);
        this.updateHeaderStyle(this.$headerWrapper, 'header', 'hoverHeader');

        this.$contentWrapper = $('<div/>')
            .addClass('content-wrapper')
            .appendTo(this.$dataGridWrapper);

        if (this.data.infiniteScroll) {
            this.subscribeEventHandler(this.$contentWrapper, 'scroll', this.loadNextPageIfNeeded.bind(this));
        }

        this.$footerWrapper = $('<div/>')
            .addClass('footer-wrapper')
            .appendTo(this.$dataGridWrapper);

        this.page = 0;
        this.currentScrollPosition = 0;
        this.loadedAllData = false;
        this.loading = false;
        this.loadedPages = 1;
        this.previousData = null;
        this.conditionalStartStates = [];
        this.footerData = null;

        this.sortParameters = [];
        this.clicksCounter = 0;

        if (this.data.defaultSortOutput) {
            this.sortParameters.push({
                output: this.data.defaultSortOutput,
                descending: this.data.defaultSortDirection === 'Descending'
            });
        }

        self.updateStyle(this.$element, '');

        this.update([{ 'initializing': true }]);
    };

    Drop.extend(DataGrid, Drop);

    DataGrid.typeName = 'DataGrid';

    DataGrid.prototype.preRender = function () {
        var self = this;
        this.piping.visibility.apply(this);
        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function (data) {
                if (!self.data.keepScrollPositionOnQueryReload) {
                    self.loadedPages = 1;
                    self.currentScrollPosition = 0;
                } else {
                    self.storeScollPosition.apply(self);
                }
                self.loadedAllData = data.totalResults < self.getPageSize();
                self.previousData = data;
                self.selectedRows = [];
                self.update(data)
                    .done(function() {
                        self.triggerPageOpened(data.totalResults, self.page, self.getPageSize());
                        self.loadNextPageIfNeeded();
                    });
            },
            this.decorateDataSourceDataForFirstPage.bind(this));

        this.piping.datasources.registerDatasourceListener(
            this.data.footerDataSource,
            function (data) {
                self.$footerWrapper
                    .empty()
                    .append(self.getFooterRow(data));
            });

        this.setUpHeaderTooltips();

        this.formatters = _.map(this.data.columns, function (column) {
            return self.piping.formatting.createFormatter(column.formatting);
        });

        this.events(windowSize,
        {
            'Changed': function() {
                if (self.previousData)
                    self.update(self.previousData);
            }
        });

        this.applyPosition();
        this.onComponentVisible(this.$element, function (isVisible) {
            if (isVisible && self.$tableRows && self.$tableHeaders) {
                self.updateColumnWidths();
                self.postDataGridRender(self.currentScrollPosition);
            }
        });
    };

    DataGrid.prototype.growsInHeight = function () {
        if (this.parent && this.parent.data.isDynamiclySizedContainer) {
            if (this.parent.getCellElementForChild) { // We are in dynamicgridlayout
                var cellElement = this.parent.getCellElementForChild(this);
                if (this.parent.data.rows.length > cellElement.rowIndex && this.parent.data.rows[cellElement.rowIndex].unit === 'auto') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }
        return false;
    };

    DataGrid.prototype.applyRelativePositioning = function () {
        if (!this.growsInHeight()) return;
        this.$dataGridWrapper
            .css({
                position: 'relative'
            });

        var css = {
            height: ''
        };

        if (this.data.centered === true) {
            css.width = this.data.size.x + 'px';
            css.margin = '0 auto';
        } else if (this.data.right != null && this.data.left == null) {
            css.marginLeft = 'auto';
            css.marginRight = this.data.right + 'px';
            css.width = this.data.size.x + 'px';
        } else if (this.data.right != null && this.data.left != null) {
            css.marginLeft = this.data.left + 'px';
            css.marginRight = this.data.right + 'px';
            css.width = 'calc(100% - ' + this.data.left + 'px' - this.data.right + 'px)';
        } else {
            css.marginLeft = (this.data.left != null ? this.data.left : this.data.position.x) + 'px';
            css.width = this.data.size.x + 'px';
        }

        this.$element.css(css);
    };

    DataGrid.prototype.setUpHeaderTooltips = function () {
        // In case the tooltip comes from a query we need to subscribe to the event listener in time,
        // because if the query is on pageload it will be too late in the place where we put together the header
        var self = this;
        this.headersWithTooltips = [];
        _.each(this.data.columns, function (column) {
            var $h = $('<span>')
                .html(html.sanitize((column.headerVisible ? column.headerText : '')));

            self.headersWithTooltips.push($h);
            var headerTooltip = new Tooltip(self, column.headerTooltip, $h)
            headerTooltip.update();
        });
    };

    DataGrid.prototype.decorateDataSourceDataForFirstPage = function (data) {
        data.doNotExecuteCountQuery = this.data.infiniteScroll;
        data.page = 0;
        data.pageSize = this.data.keepScrollPositionOnQueryReload
            ? this.loadedPages * this.getPageSize()
            : this.getPageSize();
        data.sortParameters = this.sortParameters;
    };

    DataGrid.prototype.loadNextPageIfNeeded = function () {
        var self = this;
        if (self.$contentWrapper.scrollTop() + self.$contentWrapper.height() >= self.$contentWrapper[0].scrollHeight - 30) {
            if (!self.loading && !self.loadedAllData) {
                self.storeScollPosition();
                self.loadNextPage();
            }
        }
    }

    DataGrid.prototype.onComponentVisible = function($element, callback) {
        // 1. Helper to determine if it's truly visible based on your rules
        function checkVisibility() {
            // $.is(':visible') automatically checks if the element or ANY parent is 'display: none'
            // $.css('visibility') catches if it or an ancestor is 'visibility: hidden'
            return $element.is(':visible') && $element.css('visibility') !== 'hidden';
        }

        // 2. Initial check: if it's already visible, fire immediately
        var wasVisible = checkVisibility();
        if (wasVisible) {
            callback(true);
        }

        // 3. Watch for changes to styles/classes on the element or its parents
        const observer = new MutationObserver(function (mutations) {
            mutations.every(function(mutation) {
                // Check if the mutation happened to this element or one of its ancestors
                if ($element.closest(mutation.target).length > 0) {
                    const isVisible = checkVisibility();

                    // Only trigger when the state actually flips
                    if (isVisible !== wasVisible) {
                        wasVisible = isVisible;
                        callback(isVisible);
                        return false; // break;
                    }
                }
            });
        });

        // 4. Start observing the entire document body for style changes
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['style', 'class'],
            subtree: true
        });

        // 5. Return a disconnect function
        return function() {
            observer.disconnect();
        };
    };

    DataGrid.prototype.loadNextPage = function () {
        this.loadDataForPage(this.loadedPages, false);
    };

    DataGrid.prototype.updateColumnWidths = function () {
        this.calculateColumnWidths();

        var self = this;
        _.each(this.data.columns, function (column, index) {
            if (self.data.headerEnabled) {
                self.$tableHeaders.children().eq(0).children().eq(index)
                    .css('width', column.columnSizeType === 'Pixels' ? column.columnSizeInPixels + 'px' : column.columnSizeInPercentage + '%');
            }
            self.$tableRows.children().eq(0).children().eq(index)
                .css('width', column.columnSizeType === 'Pixels' ? column.columnSizeInPixels + 'px' : column.columnSizeInPercentage + '%');
        });
    };

    DataGrid.prototype.update = function (data, forceHeaderRender) {
        if (data)
            this.results = data.results;

        var self = this;
        return when.promise(function(res) {
            self.prepareGrid();
            setTimeout(res);
        })
        .then(function(){
            return when.promise(function(res) {
                var columns = self.data.columns;
                self.renderHeadersAndRows(data, forceHeaderRender, columns);
                setTimeout(res);
            });
        })
        .then(function(){
            self.postDataGridRender(self.currentScrollPosition);
        });
    };

    DataGrid.prototype.prepareGrid = function(){
        if (this.data.headerEnabled) {
            if (!this.$tableHeaders) {
                this.$headerWrapper
                    .addClass('header-enabled');

                this.$tableHeaders = $('<table cellspacing="0" cellpadding="0" />')
                    .css({
                        height: this.data.headerHeight + 'px'
                    })
                    .addClass('table-header')
                    .appendTo(this.$headerWrapper);
            }
        } else {
            this.$headerWrapper
                .removeClass('header-enabled');
        }

        if (this.data.footerEnabled) {
            this.$footerWrapper
                .addClass('footer-enabled');
        } else {
            this.$footerWrapper
                .removeClass('footer-enabled');
        }
    };

    DataGrid.prototype.renderHeadersAndRows = function (data, forceHeaderRender, columns) {
        this.$contentWrapper
            .empty()
            .css('visibility', 'hidden');

        this.$tableRows = $('<table cellspacing="0" cellpadding="0" />')
            .addClass('table-body')
            .append($('<tbody/>').addClass('table-body-row'))
            .appendTo(this.$contentWrapper);

        this.updateItems(data, false);
        this.updateColumnWidths();

        if (forceHeaderRender && this.$headerRow) {
            this.$headerRow.remove();
            delete this.$headerRow;
            this.setUpHeaderTooltips();
        }
        if (this.data.headerEnabled && !this.$headerRow) {
            this.$headerRow = $('<thead/>')
                .css({display: 'flex'})
                .addClass('table-header-row')
                .appendTo(this.$tableHeaders);

            var self = this;
            _.each(columns, function (column, columnIndex) {
                var alignment = column.headerContentAlignment;
                if (alignment === 'start') {
                   switch (column.textAlignmentHeader) {
                        case 'Center':
                            alignment = 'center';
                            break;
                        case 'Right':
                            alignment = 'right';
                            break;
                        default:
                            break;
                    }
                }
                var $header = self.getHTMLHeaderElementByType(column, columnIndex)
                    .css({ display: 'flex', gap: column.headerIconGap, justifyContent: alignment });
                self.$headerRow.append($header);

                if (column.type !== 'Static Image' &&
                    column.type !== 'Dynamic Image' &&
                    column.type !== 'Static Text' &&
                    !column.disabledColumnSorting) {
                    $header
                        .on('click', self.sortByColumn.bind(self, column))
                        .attr('class', 'data-grid-clickable');
                }

                var padL = column.headerIconPadding && column.headerIconPadding.left ? column.headerIconPadding.left : 0; // fallback 0
                var padT = column.headerIconPadding && column.headerIconPadding.top ? column.headerIconPadding.top : 0; // fallback 0
                var padR = column.headerIconPadding && column.headerIconPadding.right ? column.headerIconPadding.right : 0; // fallback 0
                var padB = column.headerIconPadding && column.headerIconPadding.bottom ? column.headerIconPadding.bottom : 0; // fallback 0

                if (!!column.isHeaderIconEnabled && column.headerIconFile) {
                    var $headerIcon = $('<div>')
                            .addClass('icon-wrapper')
                            .css({
                                width: 'fit-content',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                paddingLeft: padL + 'px',
                                paddingTop: padT + 'px',
                                paddingRight: padR + 'px',
                                paddingBottom: padB + 'px'
                            })
                            .append(
                                $('<div>')
                                    .addClass('icon')
                                    .css({
                                        backgroundImage: 'url(' + lq.getTenantUploads(column.headerIconFile) + ')',
                                        backgroundSize: 'contain',
                                        width: (column.headerIconWidth ?? 24) + 'px', // fallback 24
                                        height: (column.headerIconHeight ?? 24) + 'px', // fallback 24
                                        backgroundRepeat: 'no-repeat',
                                    })
                            );

                    if (column.headerIconPosition === 'after')
                        $header.append($headerIcon);
                    else
                        $header.prepend($headerIcon);
                }
            });
        }
    };

    DataGrid.prototype.postDataGridRender = function (restoreScrollPosition) {
        if (!this.growsInHeight()) {
            if (this.data.headerEnabled)
                this.$tableHeaders.css('width', this.$tableRows.outerWidth() + 'px');

            if (this.data.footerEnabled)
                this.$footerWrapper.children().css('width', this.$tableRows.outerWidth() + 'px');
        }

        this.updateStyle(this.$footerWrapper, 'footer', 'hoverFooter');

        this.updateSelectedRow(this.selectedRowValue);
        this.restoreScrollPosition(restoreScrollPosition);

        this.$contentWrapper
            .css('visibility', 'inherit');
    };

    DataGrid.prototype.updateItems = function (data, replace) {
        if (!data || !data.results) return;

        var $tbody = this.$tableRows.find('tbody');

        if (replace) {
            $tbody.find('tr:gt(0)').remove();
            $tbody.scrollTop(0);

            this.results = data.results;
        } else {
            this.results = _.union(this.results, data.results);
        }

        $tbody.
            append(_.map(data.results, this.createRow.bind(this,
                this.results,
                this.results.length - data.results.length,
                data.outputs)));

        $tbody.children().eq(0)
            .css('padding', '0');
    };

    DataGrid.prototype.createRow = function(allRows, offsetIndexCurrentRows, outputs, currentRow, currentRowIndex) {
        var $currentRow = $('<tr/>');

        var actualIndex = offsetIndexCurrentRows + currentRowIndex;

        var self = this;
        $currentRow
            .append(_.map(this.data.columns, function (column) {
                var $cell = self.getHTMLRowElementByType(outputs, currentRow, column, $currentRow, column.textAlignment);

                if (column.dataGrouping && actualIndex > 0) {
                    var output = column.type === 'Dynamic Text'
                        ? column.output
                        : column.physicalFile;
                    var previousRowCellText = allRows[actualIndex - 1][output];
                    if (previousRowCellText === currentRow[output])
                        $cell.addClass('hidden-content');
                }

                return $cell;
            }));

        if (this.data.backgroundColorArg && currentRow[this.data.backgroundColorArg])
            $currentRow.css('background-color', currentRow[this.data.backgroundColorArg]);

        if (this.isEventEnabled('dblClicked') && this.isEventEnabled('clicked')) {
            $currentRow.on('click', function(e) {
                self.clicksCounter++; //count clicks

                if (self.clicksCounter === 1) {
                    self.dblClickTimer = setTimeout(function() {
                        self.clicksCounter = 0; //after action performed, reset counter
                        self.handleSingleClick(currentRow);
                    },
                    250);
                } else {
                    clearTimeout(self.dblClickTimer); //prevent single-click action
                    self.clicksCounter = 0; //after action performed, reset counter
                    self.handleDoubleClick(currentRow);
                }
            })
            .on('dblclick', function(e) {
                e.preventDefault(); //cancel system double-click event
            });
        } else if (self.isEventEnabled('dblClicked')) {
            $currentRow.on('dblclick', function () {
                self.handleDoubleClick(currentRow);
            });
        } else if (self.isEventEnabled('clicked')) {
            $currentRow.on('click', function() {
                self.handleSingleClick(currentRow);
            });
        }

        var rowCssStyle = actualIndex % 2 === 0 ? 'odd' : 'even';
        this.updateStyle($currentRow, rowCssStyle);

        $currentRow.on('selected', this.showRowAsSelected.bind(this, $currentRow));
        $currentRow.on('deselected', this.showRowAsDeselected.bind(this, $currentRow, currentRow, rowCssStyle));

        if (this.isSelected(currentRow[this.data.eventArg]))
            $currentRow.trigger('selected');

        return $currentRow;
    };

    DataGrid.prototype.handleSingleClick = function (row) {
        this.updateSelectedRow(row[this.data.eventArg]);
        this.triggerEventIfEnabled('clicked', row[this.data.eventArg]);
    };

    DataGrid.prototype.handleDoubleClick = function (row) {
        if (this.isLocked()) return;
        this.updateSelectedRow(row[this.data.eventArg]);
        this.triggerEventIfEnabled('dblClicked', row[this.data.eventArg]);
    };

    DataGrid.prototype.setValue = function (update) {
        this.resetRowSelection();
        this.updateSelectedRow(update.value);
    };

    DataGrid.prototype.getValue = function () {
        return this.supportsManyToManyData() ? this.selectedRows : _.first(this.selectedRows);
    };

    DataGrid.prototype.supportsManyToManyData = function () {
        return this.data.selection === 'multiple';
    };

    DataGrid.prototype.clearValue = function() {
        this.resetRowSelection();
    };

    DataGrid.prototype.resetRowSelection = function () {
        var $tbody = this.$tableRows.find('tbody');

        $tbody.children('.selectedRow').each(function(index, tr) {
            $(tr).trigger('deselected');
        });

        this.selectedRows = [];
    };

    DataGrid.prototype.getIndexOfRowWithId = function(id) {
        for (var i = 0; i < this.results.length; i++) {
            var result = this.results[i];

            if (result !== null && result[this.data.eventArg] === id)
                return i;
        }

        return undefined;
    };

    DataGrid.prototype.isSelected = function(rowId) {
        return !!_.find(this.selectedRows, function(selectedRowId) {
            return selectedRowId === rowId;
        });
    };

    DataGrid.prototype.updateSelectedRow = function (rowValues) {
        if (rowValues == null) return;

        var $tbody = this.$tableRows.find('tbody');

        if (!$.isArray(rowValues))
            rowValues = [rowValues];

        if (this.data.selection === 'single')
            this.resetRowSelection();

        var self = this;
        _.each(rowValues, function(rowId) {
            var rowIndex = self.getIndexOfRowWithId(rowId);

            if (rowIndex !== undefined) {
                var $row = $tbody.children().eq(rowIndex);

                if (self.isSelected(rowId)) {
                    self.selectedRows = _.reject(self.selectedRows, function(selectedRowId) {
                            return selectedRowId === rowId;
                        });
                    $row.trigger('deselected');
                } else {
                    self.selectedRows.push(rowId);
                    $row.trigger('selected');
                }
            } else {
                // row not visible at the moment
                self.selectedRows.push(rowId);
            }
        });
    };

    DataGrid.prototype.showRowAsDeselected = function($row, rowData, rowCssStyle) {
        this.updateStyle($row, rowCssStyle);

        $row.removeClass('selectedRow');

        _.each(this.data.columns, function (column, columnIndex) {
            if (column.type === 'Static Image') {
                var imageUrl = column.imageVisibility === 'Always' ? column.physicalFile : '';
                setBackgroundImage($row.children().eq(columnIndex).children().eq(0).children().eq(0), imageUrl);
            }
        });

        _.each(this.data.columns, function (column, columnIndex) {
            //when row is deselected, make custom backgrounds visible so selected state can be seen
            if (column.backgroundColor)
                $row.children().eq(columnIndex).css('background-color', rowData[column.backgroundColor]);
        });
    };

    DataGrid.prototype.showRowAsSelected = function($row) {
        this.updateStyle($row, 'selectedRow');

        $row.addClass('selectedRow');

        _.each(this.data.columns, function (column, columnIndex) {
            if (column.type === 'Static Image') {
                if (column.imageVisibility === 'Always') {
                    if (column.physicalFileHoverSelected)
                        setBackgroundImage($row.children().eq(columnIndex).children().eq(0).children().eq(0), column.physicalFileHoverSelected);
                } else {
                    setBackgroundImage($row.children().eq(columnIndex).children().eq(0).children().eq(0), column.physicalFile);
                }
            }
        });
    };

    DataGrid.prototype.updateHeaderStyle = function ($element, styleName, customStyleName) {
        if (customStyleName)
            Style.renderStyles(this, null, $element, this.data.styles, styleName, customStyleName);
        else
            Style.renderStyles(this, null, $element, this.data.styles, styleName);
    };

    DataGrid.prototype.updateStyle = function ($element, styleName, customStyleName) {
        if (customStyleName == null)
            Style.renderStyles(this, null, $element, this.data.styles, styleName);
        else
            Style.renderStyles(this, null, $element, this.data.styles, styleName, customStyleName);
    };

    DataGrid.prototype.getPaddingFormat = function (padding) {
        if (!padding)
            return '';
        var p =
            (padding.top ?? '0') + 'px ' +
            (padding.right ?? '0') + 'px ' +
            (padding.bottom ?? '0') + 'px ' +
            (padding.left ?? '0') + 'px';
        return p;
    };

    DataGrid.prototype.storeScollPosition = function () {
        this.currentScrollPosition = this.$contentWrapper.scrollTop();
    };

    DataGrid.prototype.restoreScrollPosition = function (currentScrollPosition) {
        if (currentScrollPosition !== null && currentScrollPosition !== undefined) {
            this.$contentWrapper.scrollTop(currentScrollPosition);
        } else {
            this.$contentWrapper.scrollTop(this.currentScrollPosition);
        }
    };

    DataGrid.prototype.sortByColumn = function (column) {
        if(!column) return;
        var descending = this.sortParameters.length !== 0
            && this.sortParameters[0].output === column.output
            && !this.sortParameters[0].descending;

        this.sortParameters = [{ output: column.output, descending: descending }];
        this.dispatchQuery();
    };

    DataGrid.prototype.dispatchQuery = function () {
        var self = this;
        this.piping.queryDispatcher.dispatch(
            this.data.dataSource,
            function(data) {
                self.loadedPages = 1;
                self.currentScrollPosition = 0;
                self.loadedAllData = self.getPageSize() > data.results.length;
                self.update(data, self);
                self.previousData = data;
            },
            this.decorateDataSourceDataForFirstPage.bind(this));
    };

    DataGrid.prototype.getHTMLHeaderElementByType = function (column, columnIndex) {
        var $th = $('<td/>')
            .css({
                textAlign: column.textAlignmentHeader,
                height: this.data.headerHeight + 'px'
            });

        if (column.columnSize != null)
            $th.css('width', column.columnSizeType === 'Pixels' ? column.columnSizeInPixels + 'px' : column.columnSizeInPercentage + '%');

        var $content = $('<div />');

        if (this.data.showSortingInHeader && !column.disabledColumnSorting) {
            var $sorting = $('<div class="column-sorting" />')
                .append($('<div class="sorting-ascending" />').text('▲'))
                .append($('<div class="sorting-descending" />').text('▼'));

            if (this.sortParameters.length > 0 && this.sortParameters[0].output === column.output)
                $sorting.addClass(this.sortParameters[0].descending ? 'descending' : 'ascending');

            $content.append($sorting);
        }

        var $headerTitle = $('<div class="column-title"/>');
        if (column.applyCustomPaddingForHeader && column.customPaddingForHeader) {
            $headerTitle
                .css({
                    padding: this.getPaddingFormat(column.customPaddingForHeader)
                });
        }

        $content.append($headerTitle
            .append(
                this.headersWithTooltips[columnIndex]
            ));

        if (!column.headerEnabled) {
            $content.css({
                visibility: 'hidden',
                backgroundColor: 'rgba(0, 0, 0, 0)'
            });
        }

        return $th
            .append($('<div class="table header-content">')
                .append($content));
    };

    DataGrid.prototype.getFooterRow = function (data) {
        if (data.results.length === 0)
            return $('<div/>');

        var self = this;
        var columns = this.data.columns;

        var $table = $('<table cellspacing="0" cellpadding="0" />')
            .css('overflow', 'hidden')
            .addClass('table-body');

        var $tbody = $('<tbody>')
            .addClass('table-body-row');
        $tbody.appendTo($table);
        this.$footerHeaders = $tbody;

        var row = data.results[0];

        var $row = $('<tr/>');
        $row.appendTo($tbody);

        _.each(columns, function (column) {
            if (data.results.length > 0) {
                var $cell = self.getHTMLRowElementByType(data.outputs, row, column, $row, column.textAlignmentFooter, true);
                $cell.css({
                    'white-space': 'nowrap',
                    padding: column.applyCustomPaddingForFooter ? self.getPaddingFormat(column.customPaddingForFooter) : ''
                });
                $row.append($cell);
            }
        });

        return $table;
    };

    DataGrid.prototype.getHTMLRowElementByType = function (outputs, dataOfRow, column, $row, textAlignment, isFooter) {
        var self = this;

        var $td = $('<td/>')
            .css({
                overflow: 'hidden',
                whiteSpace: (column.textTrimStyle === 'Single Line' ? 'nowrap' : 'pre-line'),
                verticalAlign: column.verticalAlign || 'top'
            });

        if (column.textTrimStyle === 'Single Line') {
            $td.find('div').css({
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
            });
        }

        var hasEventOnColumn = Object.keys(column.eventing).length !== 0;
        var hasEventOnDataGrid = Object.keys(this.data.eventing).length !== 0;

        if (!hasEventOnColumn && !hasEventOnDataGrid) {
            $td.addClass('no-event');
        }

        var $content = $('<div/>').appendTo($td);

        $content.css({
            textAlign: textAlignment,
            padding: this.getPaddingFormat(column.customPadding)
        });

        if (dataOfRow[column.queryVisible] != null) {
            var value = dataOfRow[column.queryVisible];
            if (!value)
                $td.addClass('hidden-content');
        }

        if (column.textTrimStyle === 'Dynamic Height' || column.type.indexOf('image') === -1)
            $td.css('height', this.data.rowHeight + 'px');

        if (column.columnSize)
            $td.css('width', column.columnSizeType === 'Pixels' ? column.columnSizeInPixels + 'px' : column.columnSizeInPercentage + '%');

        if (column.backgroundColor)
            $td.css('background-color', dataOfRow[column.backgroundColor]);

        //tooltip
        if (column.tooltip) {
            if (column.tooltip.option === Tooltip.hardcoded && column.tooltip.hardcodedTooltip)
                $content.attr('title', html.strip(column.tooltip.hardcodedTooltip));
            else if (column.tooltip.option === Tooltip.query)
                $content.attr('title', html.strip(dataOfRow[column.tooltip.datasourceOutput]));
        }
        else if (self.data.tooltip)
            $content.attr('title', html.strip(dataOfRow[self.data.tooltip]));

        var columnType = column.type;
        var output = column.output;

        if (self.data.footerEnabled && isFooter)
            columnType = column.footerType;

        switch (columnType) {
            case 'Input':
                var $element;
                switch (column.inputType) {
                    case 'text':
                        $element = ($('<input type="text"/>'));
                        break;
                    case 'checkbox':
                        $element = ($('<input type="checkbox"/>'));
                        break;
                    default:
                        $element = $('<div/>');
                        break;
                }
                $element.css('width', column.inputWidth + 'px').css('height', column.inputHeight + 'px');
                $element.attr('class', 'inputType');
                $element.on('click', function (event) { event.stopPropagation(); });
                $content.append($element);
                break;
            case 'Static Text':
                if (isFooter) output = column.footerStaticValue;

                if (column.eventing && column.eventing['clicked'] && column.eventing['clicked'].enabled) {
                    $content.on('click', function () {
                        self.storeScollPosition();
                        self.triggerEvent(column.eventing['clicked'].raisedEventName, dataOfRow[self.data.eventArg], $content);
                        return false;
                    });
                }
                if ($content.attr('title') === null) $content.attr('title', html.strip(output));

                var $textElement = $('<span/>').html(html.sanitize(output));
                this.applyColumnStyleToElement($textElement, column);
                $content.append($textElement);
                break;
            case 'Dynamic Text':
                if (isFooter) output = column.footerDynamicValue;

                var colType = outputs[output];
                var value = self.formatters[_.indexOf(self.data.columns, column)].convertFromLicquidFormat(colType, dataOfRow[output]);
                if (column.eventing && column.eventing['clicked'] && column.eventing['clicked'].enabled) {
                    $content.on('click', function () {
                        self.storeScollPosition();
                        self.triggerEvent(column.eventing['clicked'].raisedEventName, dataOfRow[self.data.eventArg], $content);
                        return false;
                    });
                }

                if (column.removeMarginAndPadding)
                    $td.addClass('remove-margin-and-padding');

                if ($content.attr('title') == null) $content.attr('title', html.strip(value));

                if (value) {
                    if (column.textSuffix)
                        value += column.textSuffix;

                    var $textElement = $('<span/>').html(html.sanitize(value));
                    this.applyColumnStyleToElement($textElement, column);
                    $content.append($textElement);
                }

                break;
            case 'Static Image':

                $content
                    .css("padding", this.getPaddingFormat(column.customPadding));

                var $image = this.create$image(column, '');
                this.addImageToContent($image, $content, column);

                if (column.imageVisibility === 'Always') {
                    setBackgroundImage($image, column.physicalFile);

                    if (column.physicalFileHoverSelected) {
                        $row.on('mouseover', function () {
                            setBackgroundImage($image, column.physicalFileHoverSelected);
                        });

                        $row.on('mouseout', function () {
                            if (self.isSelected(dataOfRow[self.data.eventArg]))
                                return;
                            setBackgroundImage($image, column.physicalFile);
                        });
                    }
                }
                else {
                    $row.on('mouseout', function () {
                        if (!self.isSelected(dataOfRow[self.data.eventArg]))
                            setBackgroundImage($image, "");
                    });

                    $row.on('mouseover', function () {
                        setBackgroundImage($image, column.physicalFile);
                    });
                }

                if (column.eventing && column.eventing['clicked'] && column.eventing['clicked'].enabled) {
                    $image.on('click', function () {
                        self.storeScollPosition();
                        self.triggerEvent(column.eventing['clicked'].raisedEventName, dataOfRow[self.data.eventArg], $image);
                        return false;
                    });
                }

                break;
            case 'Dynamic Image':
                $content.css("padding", this.getPaddingFormat(column.customPadding));
                var value = dataOfRow[column.physicalFile];

                if (value) {
                    if (typeof value !== 'string')
                        value = value.Url;

                    var imageUrl = dynamicContentImage.getPath({
                        imageName: value,
                        useThumbnail: true,
                        resizeOption: 'fillKeepRatio',
                        thumbnailFileType: 'png',
                        size: {
                            x: column.imageWidth,
                            y: column.imageHeight
                        }
                    });

                    var $image = this.create$image(column, imageUrl);
                    this.addImageToContent($image, $content, column);

                    if (column.eventing && column.eventing['clicked'] && column.eventing['clicked'].enabled) {
                        $image.on('click', function () {
                            self.storeScollPosition();
                            self.triggerEvent(column.eventing['clicked'].raisedEventName, dataOfRow[self.data.eventArg], $content);
                            return false;
                        });
                    }
                }

                break;
            case 'Conditional Image':
                var value = dataOfRow[output];

                var $image = this.create$image(column, lq.getTenantUploads((value ? column.truePhysicalFile : column.falsePhysicalFile)));
                this.addImageToContent($image, $content, column);

                $image.on('click', function () {
                    return self.toggleConditionalState(column, dataOfRow, $image);
                });
                break;
        }

        return $td;
    };

    DataGrid.prototype.addImageToContent = function ($image, $content, column) {
        $content
            .css({
                display: 'flex',
                justifyContent: horizontalAlignmentToFlex[column.horizontalAlign]
            })
            .append($image);
    };

    DataGrid.prototype.create$image = function (column, imageUrl) {
        var $image = $('<div />')
            .css({
                "width": column.imageWidth + "px",
                "height": column.imageHeight + "px",
                "background-image": "url(" + imageUrl + ")"
            });

        if (column.selectedResizeOption === 'stretch') {
            $image
                .css({
                    "background-size": column.imageWidth + "px " + column.imageHeight + "px",
                    "background-position": "left top"
                });
        } else if (column.selectedResizeOption === 'fillKeepRatio') {
            $image
                .css({
                    "background-size": "cover",
                    "background-position": 'center'
                });
        } else if (column.selectedResizeOption === 'completeImageKeepRatio') {
            $image
                .css({
                    "background-size": "contain",
                    "background-position": 'center'
                });
        }

        $image
            .css({
                "border-radius": column.imageRoundness + "px",
                "display": "inline-block",
                "background-repeat": "no-repeat"
            });

        return $image;
    };

    DataGrid.prototype.applyColumnStyleToElement = function ($element, column) {
        $element.css({
            'font-weight': column.textBold ? 'bold' : 'normal',
            'text-decoration': column.textUnderline ? 'underline' : '',
            'font-style': column.textItalic ? 'italic' : ''
        });
    };

    DataGrid.prototype.toggleConditionalState = function (column, dataOfRow, $div) {
        var self = this;
        var isBubleUpEvent = false;
        if (column.eventing['clicked'] && column.eventing['clicked'].enabled) {
            self.storeScollPosition();
            self.triggerEvent(column.eventing['clicked'].raisedEventName, dataOfRow[self.data.eventArg], $div);
        } else if (this.isEventEnabled('clicked')) {
            isBubleUpEvent = true;
        }

        if (column.enableConditionalState) {
            var currentValue =  dataOfRow[column.output];

            if (currentValue && (column.conditionalState === 'falseState' || column.conditionalState === 'opposite')) {
                if (column.eventing['unchecked'] && column.eventing['unchecked'].enabled) {
                    self.storeScollPosition();
                    self.triggerEvent(column.eventing['unchecked'].raisedEventName, dataOfRow[self.data.eventArg]);
                }
                dataOfRow[column.output] = false;
                self.updateSelectedRow(dataOfRow.Id);
            } else if (!currentValue && (column.conditionalState === 'trueState' || column.conditionalState === 'opposite')) {
                if (column.eventing['checked'] && column.eventing['checked'].enabled) {
                    self.storeScollPosition();
                    self.triggerEvent(column.eventing['checked'].raisedEventName, dataOfRow[self.data.eventArg]);
                } else if (this.isEventEnabled('clicked')) {
                    isBubleUpEvent = true;
                }
                dataOfRow[column.output] = true;
                self.updateSelectedRow(dataOfRow.Id);
            }
            $div.css('background-image', "url(" + lq.getTenantUploads((!currentValue ? column.truePhysicalFile : column.falsePhysicalFile)) + ")");
        }
        return isBubleUpEvent;
    };

    DataGrid.prototype.usingScrollBar = function () {
        var height = _.reduce(this.$tableRows.find('tbody').children(), function (acc, child) {
            return acc + $(child).outerHeight();
        }, 0);

        return height > this.$contentWrapper.outerHeight();
    }

    DataGrid.prototype.calculateColumnWidths = function () {
        var columns = this.data.columns;
        if (columns == null) {
            columns = [];
        }
        _.each(_.where(columns, { columnSizeType: 'undefined' }), function (column) {
            column.columnSizeType = 'Fractions';
        });

        var tableWidth = this.usingScrollBar() ? this.$dataGridWrapper.find('tr:first').outerWidth() : this.$dataGridWrapper.outerWidth();

        var pixelWidth = _.chain(columns)
            .where({ columnSizeType: 'Pixels' })
            .reduce(function (memo, column) {
                column.columnSizeInPixels = column.columnSize;
                return memo + column.columnSize;
            }, 0)
            .value();

        if (pixelWidth == null) pixelWidth = 0;

        var leftOverPixels = tableWidth - pixelWidth;
        var leftOverPercentage = 100 / tableWidth * leftOverPixels;

        var totalWeight = _.chain(columns)
            .where({ columnSizeType: 'Fractions' })
            .reduce(function (memo, column) {
                return memo + column.columnSize;
            }, 0)
            .value();

        _.each(_.where(columns, { columnSizeType: 'Fractions' }), function (column) {

            column.columnSizeInPercentage = leftOverPercentage / (totalWeight) * column.columnSize;
        });
        this.$tableRows.css('overflow-y', 'auto');
    };

    // used when a Pager is linked with this drop
    DataGrid.prototype.openPage = function(pageNumber) {
        this.loadDataForPage(pageNumber, true);
    };

    DataGrid.prototype.loadDataForPage = function (pageNumber, resetList) {
        if (this.loading)
            return;

        this.loading = true;

        var self = this;
        this.piping.queryDispatcher.backgroundDispatch(
            this.data.dataSource,
            function (data) {
                self.page = pageNumber;
                self.loadedPages = pageNumber + 1;
                self.totalResults = data.totalResults;
                self.loadedAllData = self.getPageSize() > data.results.length;
                self.loading = false;

                self.updateItems(data, resetList);
                self.triggerPageOpened(data.totalResults, self.page, self.getPageSize());
                self.loadNextPageIfNeeded();
            },
            function (params) {
                params.page = pageNumber;
                params.pageSize = self.getPageSize();
                params.doNotExecuteCountQuery = self.data.infiniteScroll;
                params.sortParameters = self.sortParameters;
            },
            function () {
                self.loading = false;
            });
    };

    DataGrid.prototype.getPageSize = function () {
        return this.data.pageSize || defaults.data.pageSize;
    };

    return DataGrid;
});
